<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <ul class="heading-ul mb-3">
          <li>
            <router-link :to="{ path: '/setup/discount-promotion' }">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ $t("setup.label.Promotion") }}</td>
            </h3>
          </li>
        </ul>
      </div>

      <div>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <vs-tabs
                alignment="fixed"
                v-model="activeTab"
                class="tab-action-btn-fill-conatiner"
              >
                <vs-tab :label="$t('setup.label.Promotion')">
                  <vx-card>
                    <div class="vx-row">
                      <div class="vx-col w-full md:w-full lg:w-full">
                        <ul class="horizontal-sm-btn flex mb-2 float-right">
                          <li>
                            <div
                              class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                            >
                              <vs-button
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-edit-2"
                                class="truncate"
                                @click="setDiscountData"
                                size="small"
                                >{{ $t("setup.label.Edit") }}</vs-button
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="w-full">
                        <div class="block overflow-x-auto">
                          <table
                            v-if="discountTriggers"
                            class="table w-full table-bordered table-striped"
                          >
                            <tr>
                              <td>
                                <b>{{ $t("setup.label.PromotionCode") }}</b>
                              </td>
                              <td>{{ discountTriggers.code }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>{{ $t("setup.label.PromotionName") }}</b>
                              </td>
                              <td>{{ discountTriggers.name }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>{{ $t("setup.label.StartDate") }}</b>
                              </td>
                              <td>
                                {{ arrToDate(discountTriggers.startDate) }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>{{ $t("setup.label.EndDate") }}</b>
                              </td>
                              <td>{{ arrToDate(discountTriggers.endDate) }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>{{ $t("setup.label.Status") }} </b>
                              </td>
                              <td>
                                {{ discountTriggers.status }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>{{ $t("setup.label.ExecutionType") }} </b>
                              </td>
                              <td>
                                {{ discountTriggers.type }}
                              </td>
                            </tr>
                            <tr>
                              <td class="border-none">
                                <b>{{ $t("setup.label.Priority") }} </b>
                              </td>
                              <td class="border-none">
                                {{ discountTriggers.priority }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </vs-tab>

                <vs-tab :label="$t('setup.label.PromotionTrigger')">
                  <div class="mr-2 mb-1 order-1">
                    <vx-card>
                      <div class="vx-row">
                        <div class="vx-col w-full md:w-full lg:w-full">
                          <ul class="horizontal-sm-btn flex mb-2 float-right">
                            <li>
                              <div
                                class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                              >
                                <vs-button
                                  color="primary"
                                  icon-pack="feather"
                                  :icon="
                                    discountTriggers.triggerData &&
                                    discountTriggers.triggerData.length
                                      ? 'icon-edit-2'
                                      : 'icon-plus'
                                  "
                                  class="truncate"
                                  @click="setTriggerData"
                                  size="small"
                                  >{{
                                    discountTriggers.triggerData &&
                                    discountTriggers.triggerData.length
                                      ? $t("setup.label.Edit")
                                      : $t("setup.label.AddPromotionTrigger")
                                  }}</vs-button
                                >
                                <vs-button
                                  color="danger"
                                  v-if="
                                    discountTriggers.triggerData &&
                                    discountTriggers.triggerData.length
                                  "
                                  icon-pack="feather"
                                  icon="icon-trash"
                                  class="truncate"
                                  size="small"
                                  @click="deleteTriggerPopup = true"
                                  >{{ $t("setup.label.Delete") }}</vs-button
                                >
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        class="vx-row"
                        v-if="
                          discountTriggers.triggerData &&
                          discountTriggers.triggerData.length
                        "
                      >
                        <div class="w-full">
                          <div class="block overflow-x-auto">
                            <table
                              class="table w-full table-bordered table-striped"
                            >
                              <tr>
                                <td>
                                  <b>{{ $t("setup.label.TriggerName") }}</b>
                                </td>
                                <td>
                                  {{ discountTriggers.triggerData[0].name }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>{{ $t("setup.label.OperationMode") }}</b>
                                </td>
                                <td>
                                  {{ discountTriggers.triggerData[0].when }}
                                </td>
                              </tr>

                              <!-- <tr>
                                <td>
                                  <b>{{ $t("setup.label.ApplicableTo") }} </b>
                                </td>
                                <td>
                                  {{
                                    discountTriggers.triggerData[0].applicableTo
                                  }}
                                </td>
                              </tr> -->
                              <!-- <tr>
                                <td>
                                  <b
                                    >{{ $t("setup.label.ApplicableValues") }}
                                  </b>
                                </td>
                                <td>
                                  <v-select
                                    label="name"
                                    multiple
                                    disabled
                                    :options="applicableValuesData"
                                    :reduce="(obj) => obj.code"
                                    v-model="applicableValues"
                                    placeholder="--Select One--"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    class="min-w-200 mb-2 max-w-xl"
                                  >
                                  </v-select>
                                </td>
                              </tr> -->
                            </table>
                          </div>
                        </div>
                        <div class="w-full">
                          <vs-table
                            :data="triggerConditionD"
                            v-if="
                              discountTriggers.triggerData &&
                              discountTriggers.triggerData.length
                            "
                          >
                            <template slot="header">
                              <div class="list-heading">
                                {{
                                  $t("setup.label.PromotionTriggerCondition")
                                }}
                              </div>
                              <div class="mr-2 mb-1 order-1">
                                <vs-button
                                  @click="openTriggerAddModal"
                                  color="success"
                                  icon-pack="feather"
                                  icon="icon-plus"
                                  size="small"
                                  >{{
                                    $t(
                                      "setup.label.AddPromotionTriggerCondition"
                                    )
                                  }}</vs-button
                                >
                              </div>
                            </template>
                            <template slot="thead">
                              <vs-th>{{
                                $t("setup.label.SalesChannel")
                              }}</vs-th>
                              <vs-th>{{ $t("setup.label.PaymentType") }}</vs-th
                              ><vs-th>{{ $t("setup.label.OrderType") }}</vs-th
                              ><vs-th>{{
                                $t("setup.label.BusinessType")
                              }}</vs-th>
                              <vs-th class="tHeadCenter">{{
                                $t("setup.label.Actions")
                              }}</vs-th>
                            </template>

                            <template slot-scope="{ data }">
                              <vs-tr
                                :key="index"
                                :data="item"
                                v-for="(item, index) in data"
                              >
                                <vs-td :data="item">{{
                                  item.salesChannel
                                }}</vs-td>
                                <vs-td :data="item">{{
                                  item.paymentType
                                }}</vs-td>
                                <vs-td :data="item">{{ item.orderType }}</vs-td>
                                <vs-td :data="item">{{
                                  item.businessType
                                }}</vs-td>

                                <vs-td class="whitespace-no-wrap" :data="item">
                                  <div class="container_img">
                                    <feather-icon
                                      icon="EditIcon"
                                      :title="$t('setup.label.Edit')"
                                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                                      @click.stop="
                                        editGlobalDiscountCondition(item)
                                      "
                                      class="icon_row"
                                    />
                                    <feather-icon
                                      icon="TrashIcon"
                                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                      color="danger"
                                      :title="$t('setup.label.Delete')"
                                      type="border"
                                      size="small"
                                      @click="
                                        conditionId = item.id;
                                        deleteDiscountCondition = true;
                                      "
                                      class="icon_row"
                                    ></feather-icon></div
                                ></vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </div>
                      </div>
                    </vx-card>
                  </div>
                </vs-tab>

                <vs-tab :label="$t('setup.label.PromotionRulesAndRates')">
                  <vx-card>
                    <div class="vx-row">
                      <div
                        class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                      >
                        <h3>{{ $t("setup.label.promotion_rule") }}</h3>
                      </div>
                      <div
                        class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full btn-place-end"
                      >
                        <div>
                          <vs-button
                            color="success"
                            icon-pack="feather"
                            icon="icon-plus"
                            class="truncate"
                            @click="createDiscountRule"
                            size="small"
                            >{{
                              $t("setup.label.create_promotion_rule")
                            }}</vs-button
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="vx-row"
                      v-if="discountRule && discountRule.length"
                    >
                      <div class="w-full">
                        <div class="block overflow-x-auto">
                          <vs-table
                            :data="discountRule"
                            v-if="discountRule.length"
                          >
                            <template slot="header"> </template>
                            <template slot="thead">
                              <vs-th>{{
                                $t("setup.label.PromotionRuleName")
                              }}</vs-th>
                              <vs-th>{{
                                $t("setup.label.AggregationType")
                              }}</vs-th>
                              <vs-th>{{ $t("setup.label.Resource") }}</vs-th>
                              <!-- <vs-th>{{
                                $t("setup.label.external_promotional_code")
                              }}</vs-th> -->
                              <vs-th>{{
                                $t("setup.label.SalesChannel")
                              }}</vs-th>
                              <vs-th>{{ $t("setup.label.PaymentType") }}</vs-th>
                              <vs-th>{{ $t("setup.label.OrderType") }}</vs-th>
                              <vs-th>{{
                                $t("setup.label.BusinessType")
                              }}</vs-th>
                              <vs-th class="tHeadCenter">{{
                                $t("setup.label.Actions")
                              }}</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                              <vs-tr
                                :key="index"
                                :data="item"
                                v-for="(item, index) in data"
                              >
                                <vs-td :data="item">{{ item.name }}</vs-td>
                                <vs-td :data="item">{{
                                  item.aggregationType
                                }}</vs-td>
                                <vs-td :data="item">{{
                                  item.resourceName
                                }}</vs-td>
                                <!-- <vs-td :data="item">{{
                                  item.externalPromotionId
                                }}</vs-td> -->
                                <vs-td :data="item">{{
                                  item.salesChannel
                                }}</vs-td>
                                <vs-td :data="item">{{
                                  item.paymentType
                                }}</vs-td>
                                <vs-td :data="item">{{ item.orderType }}</vs-td>
                                <vs-td :data="item">{{
                                  item.businessType
                                }}</vs-td>
                                <vs-td class="whitespace-no-wrap" :data="item">
                                  <div class="container_img">
                                    <feather-icon
                                      icon="PlusIcon"
                                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                                      :title="$t('setup.label.AddRate')"
                                      type="border"
                                      size="small"
                                      @click="handleAddDiscountRate(item)"
                                      class="icon_row"
                                    ></feather-icon>
                                    <feather-icon
                                      icon="EditIcon"
                                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                                      :title="$t('setup.label.EditRule')"
                                      type="border"
                                      @click="editDiscountRule(item)"
                                      size="small"
                                      class="icon_row"
                                    ></feather-icon>
                                    <feather-icon
                                      icon="TrashIcon"
                                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                      color="danger"
                                      :title="$t('setup.label.Delete')"
                                      type="border"
                                      size="small"
                                      @click="
                                        discountRuleId = item.id;
                                        deleteRulePopup = true;
                                      "
                                      class="icon_row"
                                    ></feather-icon></div
                                ></vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </vs-tab>

                <vs-tab :label="$t('setup.label.digitalContent')">
                  <DigitalContent :promoId="$route.params.id" />
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="triggerLabel"
            :active.sync="addTriggerPopup"
            class="popup-close"
          >
            <ValidationObserver ref="observer">
              <form>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('setup.label.TriggerName')"
                    >
                      <vs-input
                        :label="$t('setup.label.TriggerName')"
                        class="w-full mb-2 font-semibold starlabel"
                        v-model="name"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.OperationMode") }}
                        <span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.OperationMode')"
                      >
                        <v-select
                          label="label"
                          :options="whenOptions"
                          v-model="when"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        >
                          <template v-slot:option="option">{{
                            option.label
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <!-- <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.ApplicableTo") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="label"
                      :options="applicableToOptions"
                      v-model="applicableTo"
                      @input="getApplicableValues"
                      placeholder="--Select One--"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.label
                      }}</template>
                    </v-select>
                  </div>
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.ApplicableValues") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="name"
                      multiple
                      :options="applicableValuesData"
                      :reduce="(obj) => obj.code"
                      v-model="applicableValues"
                      placeholder="--Select One--"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                  </div>
                </div>
              </div> -->
                <!--    <div class="flex-1 flex items-start gap-4">
                <div class="flex-1">
                  <h4 class="text-center">Available Values</h4>
                  <div
                    class="border rounded-lg p-4 bg-gray-100 mt-2 overflow-auto rule-card"
                  >
                    <div
                      v-for="(plan, ind) in applicableValuesData"
                      :key="plan.code"
                      :class="[
                        'p-3 border rounded-md cursor-pointer',
                        selectedSourcePlan === plan.code
                          ? 'bg-success text-white'
                          : '',
                      ]"
                      @click="
                        selectedSourcePlan = plan.code;
                        selectedSourcePlanIndex = ind;
                      "
                    >
                      {{ plan.name }}
                    </div>
                  </div>
                </div>
                <div class="flex flex-col gap-4 py-4 my-auto">
                  <button :disabled="!selectedSourcePlan" @click="moveToTarget">
                    <feather-icon
                      icon="ArrowRightIcon"
                      title="Move right"
                      class="icon_row"
                      svgClasses="w-7 h-7 mt-2 hover:text-primary stroke-current cursor"
                    />
                  </button>
                  <button :disabled="!selectedTargetPlan" @click="moveToSource">
                    <feather-icon
                      icon="ArrowLeftIcon"
                      title="Move left"
                      class="icon_row"
                      svgClasses="w-7 h-7 mt-2 hover:text-primary stroke-current cursor"
                    />
                  </button>
                </div>
                <div class="flex-1">
                  <h4 class="text-center">Selected Values</h4>
                  <div
                    class="border rounded-lg p-4 bg-gray-100 mt-2 overflow-auto rule-card"
                  >
                    <div
                      v-for="(plan, ind) in applicableValues"
                      :key="plan.code"
                      :class="[
                        'p-3 border rounded-md cursor-pointer',
                        selectedTargetPlan === plan.code
                          ? 'bg-success text-white'
                          : '',
                      ]"
                      @click="
                        selectedTargetPlan = plan.code;
                        selectedTargetPlanIndex = ind;
                      "
                    >
                      {{ plan.name }}
                    </div>
                  </div>
                </div>
              </div> -->
                <div class="vx-row center my-4">
                  <div class="vx-col w-full">
                    <vs-button
                      color="primary"
                      class="footerButton-next mb-5"
                      @click="discountTrigger"
                      >{{ $t("setup.label.Submit") }}</vs-button
                    >
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="ruleLabel"
            :active.sync="addRulePopup"
            class="popup-close"
          >
            <ValidationObserver ref="observer3">
              <form>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('setup.label.PromotionRuleName')"
                    >
                      <vs-input
                        :label="$t('setup.label.PromotionRuleName')"
                        v-model="ruleName"
                        class="w-full mb-2 font-semibold starlabel"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.AggregationType") }}
                        <span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.AggregationType')"
                      >
                        <v-select
                          label="label"
                          v-model="discountType"
                          :options="discountTypeOptions"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        >
                          <template v-slot:option="option">{{
                            option.label
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.Resource")
                        }}<span class="required"> *</span>
                      </small>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.Resource')"
                      >
                        <v-select
                          label="code"
                          v-model="resourceId"
                          :options="resourceOptions"
                          :reduce="(obj) => obj.id"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        >
                          <template v-slot:option="option">{{
                            option.code
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('setup.label.MaxDiscount')"
                    >
                      <vs-input
                        :label="$t('setup.label.MaxDiscount')"
                        v-model="maxDiscount"
                        class="w-full mb-2 font-semibold starlabel"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div> -->
                  <!-- <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.external_promotional_code')"
                    v-model="externalPromoCode"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                </div> -->
                </div>
                <div class="vx-row mt-3">
                  <div class="vx-col w-full">
                    <h5>{{ $t("setup.label.CreateRuleCondition") }}</h5>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.SalesChannel") }}<span class="required"> *</span>
                      </small>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.SalesChannel')"
                      >
                        <v-select
                          label="code_value"
                          v-model="conditionObj.salesChannel"
                          :options="salesChannelOptions"
                          :reduce="(obj) => obj.code_value"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2 bg-white"
                        >
                          <template v-slot:option="option">{{
                            option.code_value
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.PaymentType") }}<span class="required"> *</span>
                      </small>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.PaymentType')"
                      >
                        <v-select
                          label="code_value"
                          v-model="conditionObj.paymentType"
                          :options="salesMotionOptions"
                          :reduce="(obj) => obj.code_value"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2 bg-white"
                        >
                          <template v-slot:option="option">{{
                            option.code_value
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.OrderType") }}<span class="required"> *</span>
                      </small>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.OrderType')"
                      >
                        <v-select
                          label="code_value"
                          v-model="conditionObj.orderType"
                          :options="orderTypeOptions"
                          :reduce="(obj) => obj.code_value"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2 bg-white"
                        >
                          <template v-slot:option="option">{{
                            option.code_value
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.BussinesType") }}<span class="required"> *</span>
                      </small>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.BussinesType')"
                      >
                        <v-select
                          label="code_value"
                          v-model="conditionObj.businessType"
                          :options="businessTypeOptions"
                          :reduce="(obj) => obj.code_value"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2 bg-white"
                        >
                          <template v-slot:option="option">{{
                            option.code_value
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="vx-row center my-4">
                  <div class="vx-col w-full">
                    <vs-button
                      color="primary"
                      class="footerButton-next mb-5"
                      @click="discountRuleAndRate"
                      >{{ $t("setup.label.Submit") }}</vs-button
                    >
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('setup.label.add_promotion_rate')"
            :active.sync="addRatePopup"
            class="popup-close popup-big"
          >
            <form>
              <!-- <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.RateTierName')"
                    v-model="rateTierName"
                    class="w-full font-semibold starlabel"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.RangeType") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="rangeType"
                      v-model="rangeType"
                      placeholder="--Select One--"
                      :reduce="(obj) => obj.value"
                      :options="rangeTypeOptions"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    >
                      <template v-slot:option="option">{{
                        option.rangeType
                      }}</template>
                    </v-select>
                  </div>
                </div>
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.RateType") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="label"
                      v-model="discountRateType"
                      :options="rateTypes"
                      :reduce="(obj) => obj.value"
                      placeholder="Select One"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    >
                      <template v-slot:option="option">{{
                        option.label
                      }}</template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-4">
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <vs-input
                    v-model="rate"
                    :label="$t('setup.label.Rate')"
                    class="w-full font-semibold top starlabel"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <vs-input
                    v-model="startRange"
                    :label="$t('setup.label.StartRange')"
                    class="w-full font-semibold top starlabel"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <vs-input
                    v-model="endRange"
                    :label="$t('setup.label.EndRange')"
                    class="w-full font-semibold top starlabel"
                  />
                </div>
              </div> -->
              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.validity_uom") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="validityType"
                      v-model="validityType"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(obj) => obj.value"
                      :options="validityTypeOptions"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    >
                      <template v-slot:option="option">{{
                        option.validityType
                      }}</template>
                    </v-select>
                  </div>
                </div>
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.validity_value')"
                    v-model="validity"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.external_promotional_code") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="promoName"
                      v-model="selectedPromoCode"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(obj) => obj"
                      :options="(externalPromoList && externalPromoList.allPromos) || []"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    >
                    <template v-slot:option="option">
                      {{ option.promoName }}
                      <span v-if="option.applicablePacks && option.applicablePacks[0] && option.applicablePacks[0].packName">
                        --- {{ option.applicablePacks[0].packName }}
                      </span>
                    </template>
                    </v-select>
                  </div>
                </div>
                <div
                  class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
                >
                  <!-- <vs-input
                    v-model="unit"
                    :label="$t('setup.label.Unit')"
                    class="w-full font-semibold top"
                  /> -->
                </div>
              </div>
              <div class="vx-row center my-4">
                <div class="vx-col w-full row-items">
                  <vs-button
                    @click="addRates"
                    color="success"
                    icon-pack="feather"
                    class="btn-big mb-5"
                    icon="icon-plus"
                    size="small"
                    >{{ $t("setup.label.Add") }}</vs-button
                  >
                </div>
              </div>
              <vs-table :data="rateDataArr">
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.ListOfRateTires") }}
                  </div>
                </template>
                <template slot="thead">
                  <!-- <vs-th>{{ $t("setup.label.RateTierName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.RangeType") }}</vs-th>
                  <vs-th>{{ $t("setup.label.StartRange") }}</vs-th>
                  <vs-th>{{ $t("setup.label.EndRange") }}</vs-th> -->
                  <vs-th>{{ $t("setup.label.ValidityType") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Validity") }}</vs-th>
                  <vs-th>{{ $t("setup.label.external_promotional_code") }}</vs-th>
                  <!-- <vs-th>{{ $t("setup.label.RateType") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Rate") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Unit") }}</vs-th> -->
                  <vs-th>{{ $t("setup.label.Actions") }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="item"
                    v-for="(item, index) in data"
                  >
                    <!-- <vs-td :data="item">{{ item.rateName }}</vs-td>
                    <vs-td :data="item">{{ item.rangeType }}</vs-td>
                    <vs-td :data="item">{{ item.startRange }}</vs-td>
                    <vs-td :data="item">{{ item.endRange }}</vs-td> -->
                    <vs-td :data="item">{{ item.validityType }}</vs-td>
                    <vs-td :data="item">{{ item.validity }}</vs-td>
                    <vs-td :data="item">{{ item.externalPromoName }}</vs-td>
                    <!-- <vs-td :data="item">{{ item.rateType }}</vs-td>
                    <vs-td :data="item">{{ item.rate }}</vs-td>
                    <vs-td :data="item">{{ item.baseUnit }}</vs-td> -->

                    <vs-td class="whitespace-no-wrap" :data="item">
                        <feather-icon
                          icon="TrashIcon"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          color="danger"
                          :title="$t('setup.label.Delete')"
                          type="border"
                          size="small"
                          @click="
                            rateId = item.id;
                            deleteRatePopup = true;
                          "
                          class="icon_row"
                        ></feather-icon>
                      </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </form>
            <delete-popup
              :deletePopup="deleteRatePopup"
              :title="$t('setup.label.Rate')"
              @deletePressed="deleteRate(rateId)"
              @cancelPressed="deleteRatePopup = false"
            >
            </delete-popup>
            <validation-popup
              :errorMessage="errorMessage"
              :warningPopup="warningPopup"
              :warningText="warningText"
              @closeWarning="warningPopup = false"
            ></validation-popup>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('setup.label.edit_promotion')"
            :active.sync="editDiscountPopup"
            class="popup-close"
          >
            <form>
              <ValidationObserver ref="observer">
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('setup.label.PromotionCode')"
                    >
                      <vs-input
                        :label="$t('setup.label.PromotionCode')"
                        v-model="discountCode"
                        class="w-full mb-2 font-semibold starlabel text-uppercase"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('setup.label.PromotionName')"
                    >
                      <vs-input
                        :label="$t('setup.label.PromotionName')"
                        class="w-full mb-2 font-semibold starlabel text-uppercase"
                        v-model="discountName"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.StartDate")
                        }}<span class="required">*</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.StartDate')"
                      >
                        <datepicker
                          :placeholder="$t('setup.label.select_date')"
                          v-model="startDate"
                          class="mb-2 font-semibold"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.EndDate")
                        }}<span class="required">*</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.EndDate')"
                      >
                        <datepicker
                          :placeholder="$t('setup.label.select_date')"
                          v-model="endDate"
                          class="mb-2 font-semibold"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.Status") }}
                        <span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.Status')"
                      >
                        <v-select
                          label="label"
                          :options="statusOption"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                          v-model="status"
                        >
                          <template v-slot:option="option">{{
                            option.label
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.Type") }}
                        <span class="required"> *</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('setup.label.Type')"
                      >
                        <v-select
                          label="label"
                          :options="typeOption"
                          v-model="type"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        >
                          <template v-slot:option="option">{{
                            option.label
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required|numeric"
                      v-slot="{ errors }"
                      name="$t('setup.label.Priority')"
                    >
                      <vs-input
                        :label="$t('setup.label.Priority')"
                        v-model="priority"
                        class="w-full mb-2 font-semibold starlabel"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </ValidationObserver>
              <div class="vx-row center my-4">
                <div class="vx-col w-full">
                  <vs-button
                    color="primary"
                    class="footerButton-next mb-5"
                    @click="updateDiscount"
                    >{{ $t("setup.label.Submit") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="
              $t(triggerConditionMode + ' ' + 'Promotion Trigger Condition')
            "
            :active.sync="addTriggerConditionPopup"
            class="popup-close"
          >
            <TriggerConditionComp
              :discountTriggerId="discountTriggerId"
              @onCreateSuceess="afterAddingTriggerCondition"
              @onEditSuccess="editTriggerCondition"
              :triggerCondtionData="triggerCondtionData"
              ref="triggerConditionComp"
              :mode="triggerConditionMode"
              name="Promotion"
            />
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('Edit Trigger Condition')"
            :active.sync="editTriggerConditionPopup"
            class="popup-close"
          >
            <form>
              <ValidationObserver ref="observer">
                <div class="vx-row">
                  <!-- <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.Resource") }}
                        <span class="required"> *</span></small
                      >
                      <v-select
                        label="code"
                        v-model="resourceId"
                        :options="resourceOptions"
                        :reduce="(obj) => obj.id"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.code
                        }}</template>
                      </v-select>
                    </div>
                  </div> -->
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.CustomerType") }}
                      </small>
                      <v-select
                        v-model="customerType"
                        label="categoryType"
                        :options="getCustomerTemplate.clientCategoryDatas"
                        :placeholder="$t('setup.label.SelectCategory')"
                        :reduce="(categoryType) => categoryType.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.categoryType
                        }}</template>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <!-- <vs-input
                      :label="$t('Filter Value')"
                      class="w-full mb-2 font-semibold"
                      v-model="balanceOf"
                    /> -->
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.FilterType") }}
                      </small>
                      <v-select
                        v-model="parameterName"
                        label="categoryType"
                        :options="getCustomerTemplate.clientCategoryDatas"
                        :placeholder="$t('setup.label.SelectCategory')"
                        :reduce="(categoryType) => categoryType.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.categoryType
                        }}</template>
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <!-- <vs-input
                      :label="$t('Filter Value')"
                      class="w-full mb-2 font-semibold"
                      v-model="balanceOf"
                    /> -->
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.FilterValue") }}
                      </small>
                      <v-select
                        v-model="parameterValue"
                        label="categoryType"
                        :options="getCustomerTemplate.clientCategoryDatas"
                        :placeholder="$t('setup.label.SelectCategory')"
                        :reduce="(categoryType) => categoryType.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.categoryType
                        }}</template>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("setup.label.Criteria") }}
                      </small>
                      <v-select
                        label="label"
                        :options="criteriaOptions"
                        v-model="criteria"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.label
                        }}</template>
                      </v-select>
                    </div>
                  </div>
                  <div
                    class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                  >
                    <vs-input
                      :label="$t('setup.label.Values')"
                      class="w-full mb-2 font-semibold"
                      v-model="value"
                    />
                  </div>
                </div>
              </ValidationObserver>
              <div class="vx-row center my-4">
                <div class="vx-col w-full">
                  <vs-button
                    color="primary"
                    class="footerButton-next mb-5"
                    @click="editTriggerCondition"
                    >{{ $t("setup.label.Submit") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </vs-popup>
        </div>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
        <delete-popup
          v-if="
            discountTriggers.triggerData &&
            discountTriggers.triggerData.length > 0
          "
          :deletePopup="deleteTriggerPopup"
          :title="$t('setup.label.PromotionTrigger')"
          @deletePressed="deleteTrigger(discountTriggers.triggerData[0].id)"
          @cancelPressed="deleteTriggerPopup = false"
        >
        </delete-popup>
        <delete-popup
          v-if="Object.keys(discountRule).length > 0"
          :deletePopup="deleteRulePopup"
          :title="$t('setup.label.PromotionRule')"
          @deletePressed="deleteRule(discountRuleId)"
          @cancelPressed="deleteRulePopup = false"
        >
        </delete-popup>

        <delete-popup
          :deletePopup="deleteDiscountCondition"
          :title="$t('setup.label.PromotionTriggerCondition')"
          @deletePressed="deleteDiscountConditionFunc(conditionId)"
          @cancelPressed="deleteDiscountCondition = false"
        >
        </delete-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState, mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import DeletePopup from "@/components/DeletePopup.vue";
import moment from "moment";
import vSelect from "vue-select";
import triggerCondition from "@/views/setup/Discount/discount/triggerCondition.vue";
import DigitalContent from "@/views/setup/PlanPricing/PlanContent.vue";

export default {
  data() {
    return {
      discountRuleId: "",
      entityField: "",
      entityFieldOptions: [
        { label: "POS", value: "pos" },
        { label: "Online", value: "ngb" },
      ],
      entity: "",
      entityOptions: [
        { label: "Branch", value: "branch" },
        { label: "Sales", value: "sales" },
      ],
      discountUnit: "",
      discountRate: "",
      rateTypeOptions: [
        { label: "rate1", value: "5" },
        { label: "rate2", value: "10" },
        { label: "rate3", value: "12" },
      ],
      validity: "",
      validityType: "",
      validityTypeOptions: [
        { validityType: "Year", value: "Year" },
        { validityType: "Month", value: "Month" },
        { validityType: "Days", value: "Days" },
      ],
      rangeType: "",
      rangeTypeOptions: [
        { rangeType: "Rating", value: "1" },
        { rangeType: "Billing", value: "11" },
      ],
      end_Range: "",
      start_Range: "",
      rateTierName: "",
      rateType: "",
      ruleCondition: "testString",
      loading: false,
      searchOption: 0,
      toggleTeam: true,
      descriptionItems: [5, 10, 15],
      deleteTriggerPopup: false,
      addTriggerPopup: false,
      delId: 0,
      activeTab: 0,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      whenOptions: ["Billing", "Rating"],
      operator: "",
      operatorsOptions: [
        { label: "AND", value: "AND" },
        { label: "OR", value: "OR" },
      ],
      rateDataArr: [],
      ruleId: "",
      criteriaOptions: [
        { criteriaOptions: "=", value: "=" },
        { criteriaOptions: ">", value: ">" },
        { criteriaOptions: "<", value: "<" },
        { criteriaOptions: ">=", value: ">=" },
        { criteriaOptions: "<=", value: "<=" },
      ],
      filterOptions: [{ parameterName: "Expression", label: "Expression" }],
      applicableToOptions: ["Plan", "Product", "Asset"],
      applicableValuesOptions: [],
      name: "",
      when: null,
      resourceId: null,
      customerType: null,
      parameterName: null,
      parameterNames: null,
      parameterValue: "",
      value: "",
      expression: "",
      criteria: {},
      // applicableTo: null,
      // applicableValues: [],
      ruleName: "Default Rule",
      discountType: null,
      // duration: null,
      maxDiscount: null,
      selectedPromoCode: null,
      applicableStartDate: null,
      applicableEndDate: null,
      applicableDuration: null,
      dateFormat: "dd MMMM yyyy",
      discountTypeOptions: ["Cumulative", "Continuous"],
      // durationOptions: ["30", "45", "90"],
      rateTypes: [
        { label: "Flat", value: "flat" },
        { label: "Percentage", value: "percentage" },
      ],
      unit: 0,
      rate: 0,
      discountRateType: "",
      resource: "",
      startRange: 1,
      endRange: 999999,
      discountRatesArr: [],
      applicableValuesData: [],
      addRulePopup: false,
      addRatePopup: false,
      deleteRulePopup: false,
      deleteRatePopup: false,
      rateId: "",
      startDate: null,
      endDate: null,
      discountCode: "",
      discountName: "",
      status: "ACTIVE",
      type: null,
      priority: "",
      statusOption: ["ACTIVE", "INACTIVE"],
      typeOption: ["Parallel", "Sequential"],
      editDiscountPopup: false,
      addTriggerConditionPopup: false,
      editTriggerConditionPopup: false,
      deleteDiscountCondition: false,
      balanceOf: "",
      conditionId: "",
      editData: "",
      discountId: "",
      selectedSourcePlan: null,
      selectedSourcePlanIndex: null,
      selectedTargetPlan: null,
      selectedTargetPlanIndex: null,
      triggerCondtionData: {},
      triggerConditionMode: "Add",
      conditionObj: {
        businessType: "",
        salesChannel: "",
        paymentType: "",
        orderType: "",
      },
      salesChannelOptions: [
        { code_value: "All" },
        { code_value: "POS" },
        { code_value: "Online" },
      ],
      salesMotionOptions: [
        { code_value: "All" },
        { code_value: "Credit Card" },
        { code_value: "Debit Card" },
        { code_value: "UPI" },
      ],
      orderTypeOptions: [
        { code_value: "All" },
        { code_value: "ACTIVATION" },
        // { code_value: "DISCONNECTION" },
        // { code_value: "TERMINATION" },
        // { code_value: "SUSPENTATION" },
        { code_value: "REACTIVATION" },
        { code_value: "RENEWAL BEFORE AUTOEXIPIRY" },
        { code_value: "RENEWAL AFTER EXIPIRY" },
        { code_value: "CHANGE_PLAN" },
      ],
      businessTypeOptions: [
        { code_value: "All" },
        { code_value: "Residential" },
        { code_value: "Business" },
        { code_value: "Government" },
        { code_value: "Tourist" },
        { code_value: "Student" },
      ],
    };
  },
  components: {
    AtomSpinner,
    "delete-popup": DeletePopup,
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
    TriggerConditionComp: triggerCondition,
    DigitalContent,
  },

  computed: {
    ...mapGetters({
      resourceOptions: "currencyMaster/getCurrencyList",
      getCustomerTemplate: "customer/getClientsTemplate",
    }),
    ...mapState({
      discountTriggers: (state) => state.discount.discountTriggers,
      discountRule: (state) => state.discount.discountRule,
      planList: (state) => state.planPrice.planList,
      productlist: (state) => state.serviceProducts.productlist,
      items: (state) => state.items.itemList,
      triggerConditionD: (state) => state.discount.triggerCondition,
      CreateViewReportTemplate: (state) =>
        state.discount.CreateViewReportTemplate,
      subCategoryItem: (state) => state.discount.ticketSubcategory,
      ruleEntityList: (state) => state.discount.ruleEntityList,
      ruleValueOptions: (state) => state.discount.ruleValueOptions,
      externalPromoList: (state) => state.discount.externalPromoList,
    }),
    discountTriggerId() {
      return this.discountTriggers.triggerData.length
        ? this.discountTriggers.triggerData[0].id
        : "";
    },
    ruleValueOptionsComputed() {
      return (entityKey) => {
        return this.ruleValueOptions.data[entityKey] || [];
      };
    },
    clauseList() {
      return [
        { label: "Equals", value: "=" },
        { label: "Not Equals", value: "!=" },
      ];
    },
    combinedOptions() {
      // Combine API options and dummy data
      if (
        this.CreateViewReportTemplate &&
        this.CreateViewReportTemplate.allowedParameters
      ) {
        return [
          ...this.filterOptions,
          ...(this.CreateViewReportTemplate.allowedParameters
            .filter((el) => el.parameterName.includes("Discount_"))
            .map((el) => {
              el.label = el.parameterName.replace("Discount_", "");
              return el;
            }) || []),
        ];
      }
    },
    // disableAdd() {
    //   return !this.entity.trim() || !this.entityField.trim();
    // },
    entityDropdownData() {
      return (
        this.CreateViewReportTemplate.allowedParameters
          .filter((el) => el.parameterName.includes("Discount_"))
          .map((el) => {
            el.label = el.parameterName.replace("Discount_", "");
            return el;
          }) || []
      );
    },

    ruleLabel() {
      if (this.ruleId) return this.$t("setup.label.edit_promotion_rule");
      else return this.$t("setup.label.create_promotion_rule");
    },
    triggerLabel() {
      if (
        this.discountTriggers.triggerData &&
        this.discountTriggers.triggerData.length
      )
        return this.$t("setup.label.edit_promotion_trigger");
      else return this.$t("setup.label.AddPromotionTrigger");
    },
  },
  methods: {
    async openTriggerAddModal() {
      this.triggerCondtionData = {};
      this.triggerConditionMode = "Add";
      this.$refs.triggerConditionComp.resetFields();
      this.addTriggerConditionPopup = true;
      // await this.$store.dispatch("discount/fetchTriggerEntityList");
    },
    async getValueOptionsByTemplate(templatename) {
      await this.$store.dispatch(
        "discount/fetchRuleValueOptions",
        templatename
      );
    },
    async createDiscountRule() {
      this.ruleName = "Default Rule";
      this.discountType = "";
      this.resourceId = "";
      this.maxDiscount = "";
      this.ruleId = "";
      this.operator = "";
      this.entity = "";
      this.entityField = "";
      this.conditionObj = {
        businessType: "",
        salesChannel: "",
        paymentType: "",
        orderType: "",
      };
      this.addRulePopup = true;

      await this.$store.dispatch("discount/fetchRuleEntityList");
    },
    editDiscountRule(discountRuleItem) {
      this.ruleName = discountRuleItem.name;
      this.discountType = discountRuleItem.aggregationType;
      this.resourceId = discountRuleItem.resourceId;
      this.maxDiscount = discountRuleItem.maxDiscount;
      this.ruleId = discountRuleItem.id;
      //from query i.e ruleCondition show create rule conditions
      const {
        businessType = "",
        salesChannel = "",
        paymentType = "",
        orderType = "",
      } = discountRuleItem;
      this.conditionObj = {
        businessType,
        salesChannel,
        paymentType,
        orderType,
      };
      this.addRulePopup = true;
    },
    async getExternalPromotionsMethod() {
      try {
        await this.$store.dispatch("discount/getExternalPromotionsAction");
        this.mergeExternalPromoList();
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async handleAddDiscountRate(discountRuleItem) {
      await this.getExternalPromotionsMethod();
      this.ruleId = discountRuleItem.id;
      this.rateDataArr = discountRuleItem.rateData;
      this.addRatePopup = true;
    },
    selectedDiscount() {
      // let aa = this.discountRule.filter((item) => (item.id = this.rateId));
    },
    moveToTarget() {
      if (!this.selectedSourcePlan) return;
      if (this.selectedSourcePlanIndex !== -1) {
        // const [movedPlan] = this.applicableValuesData.splice(
        //   this.selectedSourcePlanIndex,
        //   1
        // );
        // this.applicableValues.push(movedPlan);
        this.selectedSourcePlan = null;
        this.selectedSourcePlanIndex = null;
      }
    },
    moveToSource() {
      if (!this.selectedTargetPlan) return;
      if (this.selectedTargetPlanIndex !== -1) {
        // const plan = this.applicableValues.find(
        //   (el) => el.code === this.selectedTargetPlan
        // );
        // this.applicableValues.splice(this.selectedTargetPlanIndex, 1);
        // this.applicableValuesData.push(plan);
        this.selectedTargetPlan = null;
        this.selectedTargetPlanIndex = null;
      }
    },
    calculateRumExpression(value) {
      if (!value) return;
      this.expression = this.expression + value;
      this.parameterValue.row[0] + this.criteria.criteriaOptions;
      this.parameterValue = "";
      this.criteria = "";
    },
    arrToDate(dateArray) {
      const date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
      const formattedDate = moment(date).format("DD MMMM YYYY");
      return formattedDate;
    },
    // getApplicableValues() {
    //   this.applicableValuesData = [];

    //   if (this.applicableTo.includes("Product")) {
    //     this.applicableValuesData = [
    //       ...this.applicableValuesData,
    //       ...this.productlist.map((el) => {
    //         return {
    //           code: el.id,
    //           name: el.productCode + " -- " + el.productDescription,
    //         };
    //       }),
    //     ];
    //   }
    //   if (this.applicableTo.includes("Plan")) {
    //     this.applicableValuesData = [
    //       ...this.applicableValuesData,
    //       ...this.planList.map((el) => {
    //         return {
    //           code: el.id,
    //           name: el.planCode + " -- " + el.planDescription,
    //         };
    //       }),
    //     ];
    //   }
    //   if (this.applicableTo.includes("Asset")) {
    //     this.applicableValuesData = [
    //       ...this.applicableValuesData,
    //       ...this.items.map((el) => {
    //         return {
    //           code: el.id,
    //           name: el.itemCode + " -- " + el.itemDescription,
    //         };
    //       }),
    //     ];
    //   }
    // },
    async getCurrencyList() {
      try {
        await this.$store.dispatch("currencyMaster/setCurrencyList");
      } catch (e) {
        console.log("something went to wrong while Currency:", e);
      }
    },
    async deleteTrigger(id) {
      try {
        await this.$store.dispatch("discount/deleteDiscountTriggerAction", id);
        this.$store.dispatch(
          "discount/setDiscountTriggerList",
          this.$route.params.id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Promotion Trigger Deleted Successfully!",
          type: "success",
        });
        this.deleteTriggerPopup = false;
      } catch (e) {
        console.log("something went to wrong while Currency:", e);
      }
    },
    async deleteRule(id) {
      try {
        await this.$store.dispatch("discount/deleteDiscountRuleAction", id);
        this.$store.dispatch(
          "discount/setDiscountRuleData",
          this.$route.params.id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Promotion Rule Deleted Successfully!",
          type: "success",
        });
        this.deleteRulePopup = false;
      } catch (e) {
        console.log("something went to wrong while Currency:", e);
      }
    },
    async getTemplate() {
      try {
        await this.$store.dispatch("customer/setClientTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getReportsTemplate() {
      try {
        await this.$store.dispatch("discount/setReportsTemplateData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSubCategory() {
      const ParamName = `Discount_${this.parameterName}`;
      this.subCategoryItem.data = [];
      try {
        await this.$store.dispatch("discount/setTicketSubcategory", ParamName);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSubCategorys() {
      try {
        await this.$store.dispatch(
          "discount/setTicketSubcategory",
          this.parameterNames
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async discountTrigger() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        const payload = {
          discountId: this.$route.params.id,
          name: this.name,
          when: this.when,

          // applicableTo: this.applicableTo,
          // applicableValues: "",
          // applicableValues: this.applicableValues
          //   .map((el) => el.code)
          //   .join(", "),
          locale: "en",
        };
        let isUpdate = false;
        if (
          this.discountTriggers.triggerData &&
          this.discountTriggers.triggerData.length
        ) {
          // (payload.offerType = "Discount"),
          await this.$store.dispatch("discount/updateDiscountTrigger", {
            id: this.discountTriggers.triggerData[0].id,
            data: payload,
          });
          isUpdate = true;
        } else {
          await this.$store.dispatch("discount/createDiscountTrigger", payload);
        }
        await this.$store.dispatch(
          "discount/setDiscountTriggerList",
          this.$route.params.id
        );
        this.$store.dispatch(
          "discount/setTriggerConditionData",
          this.discountTriggers.triggerData[0].id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: isUpdate
            ? "Promotion Trigger Updated Successfully!"
            : "Promotion Trigger Created Successfully!",
          type: "success",
        });
        this.addTriggerPopup = false;
        this.name = "";
        this.when = "";
        this.resourceId = "";
        this.customerType = "";
        this.criteria = "";
        this.value = "";
        this.parameterName = "";
        this.parameterValue = "";
        this.$refs.observer.reset();
        // this.applicableTo = "";
        // this.applicableValues = [];

        setTimeout(() => {
          this.setTriggerData();
          this.addTriggerPopup = false;
        }, 1000);
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async discountRuleAndRate() {
      const isValid = await this.$refs.observer3.validate();
      if (!isValid) return;
      try {
        const payload = {
          discountId: this.$route.params.id,
          name: this.ruleName,
          aggregationType: this.discountType,
          resourceId: this.resourceId,
          maxDiscount: 0,
          // externalPromotionId: this.externalPromoCode,
          dateFormat: "dd MMMM yyyy",
          ruleConditionJson: "",
          ruleConditionMysql: "",
          // duration: this.duration,
          ...this.conditionObj,
        };
        if (this.ruleId) {
          await this.$store.dispatch("discount/updateDiscountRule", {
            id: this.ruleId,
            data: payload,
          });
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Promotion Rule Updated Successfully!",
            type: "success",
          });
        } else {
          await this.$store.dispatch("discount/createDiscountRule", payload);
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Promotion Rule Created Successfully!",
            type: "success",
          });
        }
        this.$store.dispatch(
          "discount/setDiscountRuleData",
          this.$route.params.id
        );
        this.addRulePopup = false;
        // reset the form
        this.ruleName = "Default Rule";
        this.discountType = null;
        this.resourceId = null;
        this.maxDiscount = null;
        this.ruleId = "";

        this.$refs.observer3.reset();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    mergeExternalPromoList() {
      this.externalPromoList.allPromos = [
        ...(this.externalPromoList.globalPromos || []),
        ...(this.externalPromoList.customPromos || [])
      ];
    },
    async addRates() {
      if (
        // !this.rateTierName ||
        // !this.rangeType ||
        // !this.startRange ||
        // !this.endRange ||
        !this.validityType ||
        !this.validity ||
        !this.selectedPromoCode
        // !this.discountRateType ||
        // !this.rate
      ) {
        this.warningPopup = true;
        this.errorMessage = "";
        this.warningText = "Fill the required fields!";
      } else {
        try {
          const externalPackIds = this.selectedPromoCode && this.selectedPromoCode.applicablePacks
            ? this.selectedPromoCode.applicablePacks.map(pack => pack.packId).join(',')
            : "0";

          const payloadData = {
            discountRuleId: this.ruleId,
            rateName: this.dis,
            rangeType: this.rangeType,
            startRange: this.startRange,
            endRange: this.endRange,
            // resourceId: this.resource,
            validityType: this.validityType,
            validity: this.validity,
            rate: 0,
            discountRateType: this.discountRateType,
            externalPromoId: this.selectedPromoCode.promoId,
            externalPackIds: externalPackIds,
            externalPromoName: this.selectedPromoCode.promoName,
            baseUnit: 0,
            locale: "en",
          };
          await this.$store.dispatch(
            "discount/createDiscountRate",
            payloadData
          );
          this.$store.dispatch(
            "discount/setDiscountRuleData",
            this.$route.params.id
          );
          this.ruleId = null;
          this.resetAddDiscountForm();
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Add Promotion Rate Successfully!",
            type: "success",
          });
          this.addRatePopup = false;
        } catch (e) {
          this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          );
          this.warningPopup = true;
          this.errors = e.message.errors;
        }
      }
    },
    async afterAddingTriggerCondition() {
      try {
        this.$store.dispatch(
          "discount/setTriggerConditionData",
          this.discountTriggers.triggerData[0].id
        );
        this.balanceOf = "";
        this.resourceId = "";
        this.customerType = "";
        this.parameterName = "";
        this.parameterNames = "";
        this.parameterValue = "";
        this.criteria = "";
        this.value = "";
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Add Promotion Trigger Condition Successfully!",
          type: "success",
        });
        this.addTriggerConditionPopup = false;
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async editGlobalDiscountCondition(item) {
      this.triggerConditionMode = "Edit";
      this.triggerCondtionData = item;
      this.addTriggerConditionPopup = true;
    },
    async editTriggerCondition() {
      try {
        this.$store.dispatch(
          "discount/setTriggerConditionData",
          this.discountTriggers.triggerData[0].id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Edit Promotion Trigger Condition Successfully!",
          type: "success",
        });
        // this.editTriggerConditionPopup = false;
        this.addTriggerConditionPopup = false;
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async deleteRate(id) {
      try {
        await this.$store.dispatch("discount/deleteDiscountRateAction", id);
        this.$store.dispatch(
          "discount/setDiscountRuleData",
          this.$route.params.id
        );
        this.rateDataArr = this.rateDataArr.filter((el) => el.id !== id);
        this.$toasted.success("Deleted Successfully", {
          duration: 2000,
        });
        this.deleteRatePopup = false;
      } catch (e) {
        console.log("something went to wrong while Currency:", e);
      }
    },
    async deleteDiscountConditionFunc(id) {
      try {
        await this.$store.dispatch("discount/deleteTriggerConditionData", id);
        this.$store.dispatch(
          "discount/setTriggerConditionData",
          this.discountTriggers.triggerData[0].id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Promotion Trigger Condition Deleted Successfully!",
          type: "success",
        });
        this.deleteDiscountCondition = false;
      } catch (e) {
        console.log("something went to wrong while Currency:", e);
      }
    },
    async updateDiscount() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const payload = {
          code: this.discountCode,
          name: this.discountName,
          startDate: moment(this.startDate).format("DD MMMM yyyy"),
          endDate: moment(this.endDate).format("DD MMMM yyyy"),
          status: this.status,
          type: this.type,
          priority: this.priority,
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          offerType: "Promotion",
        };
        await this.$store.dispatch("discount/updateDiscountAction", {
          id: this.$route.params.id,
          data: payload,
        });
        this.editDiscountPopup = false;
        this.resetForm();
        this.$refs.observer.reset();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Promotion Updated Successfully!",
          type: "success",
        });
        this.$store.dispatch(
          "discount/setDiscountTriggerList",
          this.$route.params.id
        );
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    resetForm() {
      this.discountCode = "";
      this.discountName = "";
      this.startDate = moment().format("DD MMMM YYYY");
      this.endDate = moment().format("DD MMMM YYYY");
      this.status = "";
      this.type = "";
      this.priority = "";
    },
    setDiscountData() {
      this.discountCode = this.discountTriggers.code;
      this.discountName = this.discountTriggers.name;
      this.startDate = this.arrToDate(this.discountTriggers.startDate);
      this.endDate = this.arrToDate(this.discountTriggers.endDate);
      this.status = this.discountTriggers.status;
      this.priority = this.discountTriggers.priority;
      this.editDiscountPopup = true;
      this.type = this.discountTriggers.type;
    },
    setTriggerData() {
      this.name = this.discountTriggers.name;
      if (
        this.discountTriggers.triggerData &&
        this.discountTriggers.triggerData.length
      ) {
        this.name = this.discountTriggers.triggerData[0].name;
        this.when = this.discountTriggers.triggerData[0].when;

        // this.applicableTo = this.discountTriggers.triggerData[0].applicableTo;
        // this.getApplicableValues();
        let obj = {};
        this.discountTriggers.triggerData[0].applicableValues.forEach(
          (el) => (obj[el] = true)
        );

        // this.applicableValues = this.applicableValuesData.filter(
        //   (el) => obj[el.code]
        // );
        let obj2 = {};
        // this.applicableValues.forEach((el) => (obj2[el.code] = true));
        this.applicableValuesData = this.applicableValuesData.filter(
          (el) => !obj2[el.code]
        );
      }
      this.$refs.observer.reset();
      this.addTriggerPopup = true;
    },
    resetAddDiscountForm() {
      this.rateTierName =
        this.discountTriggers && this.discountTriggers.name
          ? this.discountTriggers.name
          : "";

      this.rangeType = "11";
      this.startRange = 1;
      this.endRange = 999999;
      // this.resource = null;
      this.validityType = "Month";
      this.validity = null;
      this.selectedPromoCode = null;
      this.rate = null;
      this.discountRateType = "percentage";
      this.unit = null;
    },
  },

  async mounted() {
    this.loading = true;
    await this.$store.dispatch(
      "discount/setDiscountTriggerList",
      this.$route.params.id
    );
    await this.getCurrencyList();
    await this.getTemplate();
    await this.getReportsTemplate();
    await this.$store.dispatch(
      "discount/setDiscountRuleData",
      this.$route.params.id
    );
    const userData = sessionStorage.getItem("ngb:user");
    const user = JSON.parse(userData);
    const userId = user.userId;
    await this.$store.dispatch("planPrice/fetchPlanList", userId);
    await this.$store.dispatch("serviceProducts/setProductList");
    await this.$store.dispatch("items/setItemList");
    if (
      this.discountTriggers.triggerData &&
      this.discountTriggers.triggerData.length
    ) {
      await this.$store.dispatch(
        "discount/setTriggerConditionData",
        this.discountTriggers.triggerData[0].id
      );
    }
    this.loading = false;
    setTimeout(() => {
      this.setTriggerData();
      this.addTriggerPopup = false;
    }, 1000);
    this.resetAddDiscountForm();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.popup-big ::v-deep .vs-popup {
  width: 70vw !important;
}
.align-btn {
  margin-top: 1rem;
}
.btn-big {
  width: 212px;
  height: 42px;
}
.btn-place-end {
  justify-content: flex-end;
  display: flex;
}
.row-items {
  align-items: center;
  justify-content: center;
  display: flex;
}
.nested-bg {
  background-color: #cee0ec;
}
.rule-card {
  height: 300px;
  min-width: 250px;
  background-color: cornsilk;
  border: 1px solid #ede4e4;
}
</style>
